module.exports = __webpack_public_path__ + "media/img/avatars/products/product-3-6e4ecb6183500b2c3be14fa902970a28.jpg";